export default __webpack_public_path__ + "static/media/pending-transactions.9cb98706.svg";